import { Indicator, MessageBox, Toast } from 'mint-ui'
// import html2canvas from 'html2canvas'
import wx from 'weixin-js-sdk'
import gcoord from 'gcoord'
import packageJson from '../../../package.json'
import axios from 'axios'
// import { resolve } from 'url'
export default {
  version: packageJson.version,
  isWeiXin: (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'),
  isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
  isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
  subFlag: true,

  isApp() {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('apicloud') != -1) {
      localStorage.setItem('isApp', true)
    } else {
      localStorage.setItem('isApp', false)
    }
    return this.getLocalStorage('isApp')
  },
  isFromApp() {
    const ua = navigator.userAgent
    return ua.includes('Html5Plus') || ua.includes('uni-app') || window.plus !== undefined
  },
  isMPaaS() {
    const ua = navigator.userAgent.toLowerCase()
    let falg
    if (ua.indexOf('mpaas') != -1) {
      falg = true
    } else {
      falg = false
    }
    return falg
  },

  isAppRootWin() {
    return (typeof (api) !== 'undefined' && api.winName == 'root')
  },

  isUndefined(obj) {
    return typeof (obj) === 'undefined'
  },

  post(url, param, successCallback, errorCallback, _self, isShowIndicator, cancelToken) {
    if (!isShowIndicator) {
      Indicator.open({
        spinnerType: 'fading-circle'
      })
    }

    const that = this
    const isFromApp = this.isFromApp()
    // const startTime = new Date()
    return axios.post(url, param, cancelToken).then(function(response) {
      if (!isShowIndicator) {
        Indicator.close()
      }
      console.log('response', JSON.stringify(response))
      switch (response.data.status) {
        case 200:
          successCallback && successCallback(JSON.parse(JSON.stringify(response.data.data).trim()))
          break
        case 401:
          if (isFromApp) {
            uni.reLaunch({ // eslint-disable-line
              url: '/pages/forApp/login'
            })
          } else {
            if (that.isMPaaS() && url.includes('fmsContent/getFmsUrl')) {
              that.mPassRouter({ fullPath: location.origin + '/v2/login?loginPage=loginPage' }, {})
            } else if (localStorage.getItem('inUniApp') === '1' || localStorage.getItem('inWxMinapp') === '1') { // 在uniapp打包的app内
              uni.reLaunch({ // eslint-disable-line
                url: '/pages/login/login'
              })
            }
            // 请求401会跳转登录页面
            // window.location.replace(_self._Api.HOSTOLD + 'v2/login')
          }
          break
        case 4000:
          that.showMsgBox(response.data.msg)
          break
        case 4001:
          that.showMsgBoxConfirm('请认证后操作', action => {
            if (action) {
              window.top.location.href = '/v2/member/personalCertification?fullPath=' + _self.$route.fullPath
            }
          })
          break
        // 认证
        case 4002:
          // 会员中心
          that.showMsgBoxConfirm('对不起，只有付费会员才能查看。您还未付费，请您先完成付费', action => {
            if (action) {
              window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + _self.$route.fullPath
            }
          })
          break
        case 5001:
          // 没有进入权限的页面自动跳转到个人中心
          that.showMsgBoxConfirm(response.data.msg, action => {
            window.location.href = '/v2/member/center'
          })
          break
        case 502:
          // 没有进入权限的页面自动跳转到个人中心
          // that.showMsgBoxConfirm(response.data.msg, action => {
          location.replace('/v2/fms')
          // })
          break
        case 4003:
          // 没有实名认证进入到认证页面
          that.showMsgBoxConfirm(response.data.msg, action => {
            errorCallback && errorCallback()
            if (action) {
              window.location.href = '/v2/member/center'
            }
          }, { confirmButtonText: '去认证' })
          break
        default:
          that.showMsgBox(response.data.msg)
          errorCallback && errorCallback(response.data)
          break
      }
    }).catch(function(error) {
      if (error.response) {
        switch (error.response.status) {
          case 0: // 网络不通
            // this.toast('warning', '网络暂时未能连通')
            break
          case 401: // 未登录
            if (isFromApp) {
              uni.reLaunch({ // eslint-disable-line
                url: '/pages/forApp/login'
              })
            } else if (localStorage.getItem('inUniApp') === '1' || localStorage.getItem('inWxMinapp') === '1') { // 在uniapp打包的app内
              if (url.indexOf('video-api/getVideoUrl') != -1 || url.indexOf('search-api/dataOperate/collection') != -1) {
                uni.reLaunch({ // eslint-disable-line
                  url: '/pages/login/login'
                })
              }
            }
            break
          case 521: // 超时
            console.log(error.response.status)
            break
          case 500:
            that.showMsgBox('服务开小差了,稍等片刻再访问')
            Indicator.close()
            break
          case 522: // 错误
            // this.init();
            break
          case 523:
            // this.toast('danger', '当前时间存在较大偏差')
            break
          case 524:
            // this.toast('danger', '未找到相关数据')
            break
          default:
            // 其它错误，暂不处理
            break
        }
      } else if (error.request) {

        // console.log(error.request);
      } else {

        // console.log('Error', error.message);
      }
    })
  },

  ajaxError(response) {
    switch (response.status) {
      case 0: // 网络不通
        this.showMsgBox('网络暂时未能连通')
        break
      case 401: // 未登录
      case 404:
      case 521: // 超时
        this.showMsgBox('网络超时')
        break
      case 522: // 错误
        break
      case 523:
        this.showMsgBox('当前时间存在较大偏差')
        break
      case 524:
        this.showMsgBox('未找到相关数据')
        break
      default:
        this.showMsgBox('服务器异常')
        break
    }
  },

  getUserSession(self, code) {
    if (code) {
      self.post(self._Api.POST_COMMON_GET_SEESION, { code: code }, (data) => {
        self.$cookie.set('sid', data.sessionId)
        window.location.href = location.href
      }, (data) => {

      }, self, true)
    } else {
      // window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx30a4b758b4852f88&redirect_uri=" + location.href + "&action=viewtest&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx30a4b758b4852f88&redirect_uri=' + escape(location.href) + '&action=viewtest&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
      // self.setLocalStorage(self._Api.LOCAL_STORAGE_AUTH_LOGIN_FLAG, true);
    }
  },

  getUserLog(successCallback, errorCallback, self) {
    this.post(self._Api.POST_WXAUTH_USER_LOG, {}, (data) => {
      if (data.verifyStatus) {
        errorCallback && errorCallback(data)
      } else {
        successCallback && successCallback(data)
      }
    }, () => {
    }, self, true)
  },

  getUserStatus(self, successCallback, errorCallback, nextParams, standard, cirFlag) {
    // /** 未认证 */
    // NO_AUTH(0, "未认证"),
    //   /** 已认证 */
    //   AUTH(1, "已认证"),
    //   /** 已付费 */
    //   VIP(2, "已付费");
    this.post(self._Api.POST_USER_STATUS, {}, (data) => {
      switch (data.userStatus) {
        case 0:
          if (standard == 2) {
            // 认证 + 开通会员
            if (!cirFlag) {
              nextParams.userStatus = data.userStatus
              self.$router.push({ name: 'certification', query: nextParams })
            } else {
              // this.showMsgBoxConfirm('对不起，只有付费会员才能查看！您还未付费，请您先完成付费！', action => {
              //   if (action) {
              //     //开通会员
              //     nextParams.userStatus = data.userStatus
              //     window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + nextParams.fullPath
              //       + '&userStatus=' + nextParams.userStatus
              //   }
              // })
              MessageBox.confirm('对不起，只有付费会员才能查看！您还未付费，请您先完成付费！').then(action => {
                if (action) {
                  nextParams.userStatus = data.userStatus
                  window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + nextParams.fullPath +
                    '&userStatus=' + nextParams.userStatus + '&userTitle=' + document.title
                  // self.$router.replace({name: 'openMember', query: nextParams});
                }
              }).catch(() => {
                errorCallback && errorCallback()
              })
            }

            // }
            // });
          } else if (standard == 1) {
            // 开通会员
            // this.showMsgBoxConfirm('对不起，只有付费会员才能查看！您还未付费，请您先完成付费！', action => {
            //   if (action) {
            //     //开通会员
            //     nextParams.userStatus = data.userStatus
            //     window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + nextParams.fullPath
            //       + '&userStatus=' + nextParams.userStatus
            //     //self.$router.replace({name: 'openMember', query: nextParams});
            //   }
            // })
            MessageBox.confirm('对不起，只有付费会员才能查看！您还未付费，请您先完成付费！').then(action => {
              if (action) {
                nextParams.userStatus = data.userStatus
                window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + nextParams.fullPath +
                  '&userStatus=' + nextParams.userStatus + '&userTitle=' + document.title
              }
            }).catch(() => {
              errorCallback && errorCallback()
            })
          } else {
            // 认证
            // this.showMsgBoxConfirm('对不起，只有认证会员才能查看！您还未认证，请您先完成认证！', action => {
            //   if (action) {
            // 开通会员
            nextParams.userStatus = data.userStatus
            self.$router.push({ name: 'certification', query: nextParams })
            // }
            // });
          }
          break
        case 1:
          if (standard == 2) {
            MessageBox.confirm('对不起，只有付费会员才能查看！您还未付费，请您先完成付费！').then(action => {
              if (action) {
                nextParams.userStatus = data.userStatus
                window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + nextParams.fullPath +
                  '&userStatus=' + nextParams.userStatus + '&userTitle=' + document.title
                // self.$router.replace({name: 'openMember', query: nextParams});
              }
            }).catch(() => {
              errorCallback && errorCallback()
            })
          } else {
            nextParams.userStatus = data.userStatus
            successCallback && successCallback(data)
          }
          break
        case 2:
          // nextParams.userStatus = data.userStatus;
          successCallback && successCallback(data)
          break
      }
    }, errorCallback, self, !cirFlag)
  },

  getSlyYou(self, successCallback, errorCallback) {
    this.post(self._Api.POST_WXAUTH_SLY_YOU, {}, (data) => {
      successCallback && successCallback(data)
    }, () => {

    }, self)
  },
  getUserInfo(self) {
    return new Promise((resolve, reject) => {
      this.post(self._Api.POST_BASE_PERSONAL_INFO, {},
        data => {
          localStorage.setItem('userInfo', JSON.stringify(data))
          resolve(data)
        }, () => {
          reject()
        }, self
      )
    })
  },
  showMsgBox(msg, title) {
    MessageBox({
      title: title || '提示',
      message: msg
    })
  },

  showMsgBoxThen(msg, callback) {
    MessageBox.alert(msg, '提示').then(action => {
      if (action) {
        callback && callback()
      }
    })
  },

  showMsgBoxConfirm1(msg, confirmCallback, cancelBack, options, vm) {
    MessageBox.confirm(msg, '提示', options).then(action => {
      // vm._Collect.ctrlInit(vm._Enums.COLLECT_MODULE.COMM_MSG_BOX_CONFIRM, vm, {
      //   title: '提示',
      //   msg: msg
      // });
      confirmCallback && confirmCallback(true)
    }, cancel => {
      // vm._Collect.ctrlInit(vm._Enums.COLLECT_MODULE.COMM_MSG_BOX_CONFIRM, vm, {
      //   confirmTitle: '提示',
      //   confirmMsg: msg
      // });
      cancelBack && cancelBack(false)
    }).catch(() => {

    })
  },

  showMsgBoxConfirm(msg, confirmCallback, options, vm) {
    MessageBox.confirm(msg, '提示', options).then(action => {
      // vm._Collect.ctrlInit(vm._Enums.COLLECT_MODULE.COMM_MSG_BOX_CONFIRM, vm, {
      //   title: '提示',
      //   msg: msg
      // });
      confirmCallback && confirmCallback(true)
    }, cancel => {
      // vm._Collect.ctrlInit(vm._Enums.COLLECT_MODULE.COMM_MSG_BOX_CONFIRM, vm, {
      //   confirmTitle: '提示',
      //   confirmMsg: msg
      // });
      confirmCallback && confirmCallback(false)
    }).catch(() => {

    })
  },

  showToast(msg, iconClass) {
    Toast({
      message: msg,
      iconClass: iconClass || 'icon icon-success',
      className: 'z-index-max'
    })
  },

  setLocalStorage(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
  },

  getLocalStorage(key) {
    return JSON.parse(localStorage.getItem(key))
  },

  removeLocalStroageByKey(key) {
    localStorage.removeItem(key)
  },

  log(o) {
    // console.log(JSON.parse(JSON.stringify(o)))
  },

  copyObject(o) {
    return JSON.parse(JSON.stringify(o))
  },

  getByteLen(str) {
    let len = 0
    for (let i = 0; i < str.length; i++) {
      const a = str.charAt(i)
      if (a.match(/[^\x00-\xff]/ig) != null) {
        len += 2
      } else {
        len += 1
      }
    }
    return len
  },

  getQueryString(paramName) {
    const reg = new RegExp('(^|&)' + paramName + '=([^&]*)(&|$)', 'i')
    const r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  },

  isArrayInclude: function(key, value, arr) {
    let item = ''
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][key] == value) {
        item = arr[i]
        break
      }
    }
    return item
  },

  getUserAgent() {
    // localStorage.setItem('browserObj', '')
    // let browserObj = this.getLocalStorage('browserObj');
    // if (browserObj) {
    //   return browserObj;
    // } else {
    const ua = navigator.userAgent.toLowerCase()

    let platForm = ''
    let browserKernel = ''
    if (/iphone|ipad|ipod/.test(ua)) {
      platForm = 'ios'
    } else if (/android/.test(ua)) {
      platForm = 'android'
    } else {
      platForm = 'pc'
    }

    if (ua.match(/crios\/([\d.]+)/i)) {
      browserKernel = ua.match(/crios\/([\d.]+)/i)
    } else if (ua.match(/Opera\/([\d.]+)/i)) {
      browserKernel = ua.match(/opera\/([\d.]+)/i)
    } else if (ua.match(/Safari\/([\d.]+)/i)) {
      browserKernel = ua.match(/safari\/([\d.]+)/i)
    } else if (ua.match(/WebKit\/([\d.]+)/i)) {
      browserKernel = ua.match(/webkit\/([\d.]+)/i)
    }

    const browser = {
      weixin: ua.match(/MicroMessenger\/([^\s]+)/i),
      platForm: platForm,
      browserKernel: browserKernel
    }
    this.setLocalStorage('browserObj', browser)
    return browser
    // }
  },

  uiOpenImg(imageUrls) {
    const that = this
    if (!that.imageBrowser) {
      that.imageBrowser = api.require('imageBrowser')
    }

    that.imageBrowser.openImages({
      imageUrls: imageUrls
    })
  },

  wxPay(jsApiParameters, callback) {
    if (localStorage.getItem('inWxMinapp') === '1') { // 微信小程序
      const src = `/pages/transfer/index?webUrl=${encodeURIComponent(location.href)}&params=${encodeURIComponent(jsApiParameters)}`
      uni.navigateTo({ // eslint-disable-line
        url: src
      })
      return
    }
    if (this.isApp()) {
      const wxPay = api.require('wxPay')
      wxPay.config({
        // notifyUrl: location.origin + '/kaxiuyun/wxpay/notify.htm'
      }, function(ret, err) {
        if (ret.status) {
          wxPay.pay(JSON.parse(jsApiParameters || ''), function(ret, err) {
            if (ret.status) {
              callback && callback()
            }
          })
        }
      })
    } else if (this.isMPaaS()) {
      window.AlipayJSBridge && AlipayJSBridge.call('gzwxPay', JSON.parse(jsApiParameters || ''), (data) => { // eslint-disable-line
        callback && callback(data)
      })
    } else {
      WeixinJSBridge.invoke('getBrandWCPayRequest', JSON.parse(jsApiParameters || ''), function(res) {
        WeixinJSBridge.log(res.err_msg)
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          callback && callback()
        }
      })
    }
  },
  toPay(orderId, callback) {
    const src = `/pages/order/pay?orderId=${orderId}`
    uni.navigateTo({ // eslint-disable-line
      url: src
    })
  },
  wxPayNew(jsApiParameters) {
    if (localStorage.getItem('inWxMinapp') === '1') { // 微信小程序
      const src = `/pages/transfer/index?params=${encodeURIComponent(jsApiParameters)}&webUrl=liveCurricuDetail`
      uni.navigateTo({ // eslint-disable-line
        url: src
      })
      return
    }
  },

  getKaluliAuth(self) {
    if (localStorage.getItem('inWxMinapp') === '1') return
    const authorize = sessionStorage.getItem('authorize')
    if (window.location.href.indexOf('kaluli') == -1 && !authorize) {
      this.post(self._Api.POST_GET_GETKALULIAPPID, {}, (data) => {
        if (data) {
          const hr = window.location.href.substr(0, window.location.href.indexOf('code=') - 1) || window.location.href
          window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + data.appId + '&redirect_uri=' + escape(hr) + '&action=viewtest&response_type=code&scope=snsapi_base&state=kaluli#wechat_redirect')
        }
      }, () => {
      }, self, true)
    } else if (!authorize) {
      const reg = new RegExp('(^|&)code=([^&]*)(&|$)')
      const r = location.search.substr(1).match(reg)
      const code = (r == null ? null : decodeURI(r[2]))
      this.post(self._Api.POST_GET_GETKLLOPENIDBYCODE, { code: code }, (data) => {
      }, () => {
      }, self, true)
      sessionStorage.setItem('authorize', true)
      history.back()
    }
  },
  collectPageViewNew(options, self, flag) {
    const that = this
    const isApp = that.getLocalStorage('isApp')
    const userinfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userinfo.userId) {
      var maidianList = []
      if (localStorage.getItem('maidianList')) {
        maidianList = JSON.parse(localStorage.getItem('maidianList'))
      }
      // 获取当前年月日时分秒
      // 获取当前日期和时间
      const now = new Date()
      // 获取年份
      const year = now.getFullYear()
      // 获取月份（注意：月份是从0开始的，1月是0，12月是11）
      const month = String(now.getMonth() + 1).padStart(2, '0')
      // 获取日期
      const day = String(now.getDate()).padStart(2, '0')
      // 获取小时
      const hours = String(now.getHours()).padStart(2, '0')
      // 获取分钟
      const minutes = String(now.getMinutes()).padStart(2, '0')
      // 获取秒数
      const seconds = String(now.getSeconds()).padStart(2, '0')
      if (!options.source) {
        options.source = isApp ? '安卓APP' : '小程序'
      }
      const params = {
        time: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
        content: {
          type: options.type,
          source: options.source,
          target: options.target,
          remark: options.remark,
          searchKey: options.searchKey,
          userId: userinfo.userId
        }
      }
      maidianList.push(params)
      localStorage.setItem('maidianList', JSON.stringify(maidianList))
      if (maidianList.length >= 5) {
        if (flag) {
          self.post(options.postUrl, { list: maidianList }).then((response) => {
            localStorage.setItem('maidianList', '')
          })
        } else {
          that.post(options.postUrl, { list: maidianList }, () => {
            localStorage.setItem('maidianList', '')
          }, () => {
          }, self)
        }
      }
    }
  },
  collectPageView(options, self, flag) {
    const that = this
    const isApp = that.getLocalStorage('isApp')
    const browserObj = that.getUserAgent()
    const version = localStorage.getItem('newVersion') ? localStorage.getItem('newVersion') : that.version
    const params = {
      source: isApp ? 'APP' : 'WEIXIN',
      platForm: browserObj.platForm || '',
      version: isApp ? version : '',
      kernel: browserObj.browserKernel[0] || ''
    }
    params.moduleType = options.moduleType || ''
    params.optionType = options.optionType || ''
    params.operatePage = options.operate_page || ''
    params.param1 = options.url || location.href
    params.param2 = options.title || ''
    params.param3 = options.keyword || ''
    params.param4 = JSON.stringify(options.param4) || ''
    params.param5 = options.params5 || options.param5 || ''

    if (flag) {
      self.post(options.postUrl, params).then((response) => {
      })
    } else {
      that.post(options.postUrl, params, () => {
      }, () => {
      }, self)
    }
  },

  collectPageView2(options, self, flag) {
    const that = this
    const isApp = that.getLocalStorage('isApp')
    const browserObj = that.getUserAgent()
    const version = localStorage.getItem('newVersion') ? localStorage.getItem('newVersion') : that.version
    const params = {
      source: isApp ? 'APP' : 'WEIXIN',
      platForm: browserObj.platForm || '',
      version: isApp ? version : '',
      kernel: browserObj.browserKernel[0] || ''
    }
    params.moduleType = options.moduleType || ''
    params.optionType = options.optionType || ''
    params.operatePage = options.operate_page || ''
    params.param1 = options.param1 || ''
    params.param2 = options.param2 || ''
    params.param3 = options.param3 || ''
    params.param4 = JSON.stringify(options.param4) || ''
    params.param5 = options.params5 || options.param5 || ''

    if (flag) {
      self.post(options.postUrl, params).then((response) => {
      })
    } else {
      that.post(options.postUrl, params, () => {
      }, () => {
      }, self, true)
    }
  },

  collectPageView3(options, self, callback) {
    const that = this
    const isApp = that.getLocalStorage('isApp')
    const browserObj = that.getUserAgent()
    const version = localStorage.getItem('newVersion') ? localStorage.getItem('newVersion') : that.version
    const params = {
      source: isApp ? 'APP' : 'WEIXIN',
      platForm: browserObj.platForm || '',
      version: isApp ? version : '',
      kernel: browserObj.browserKernel[0] || ''
    }
    params.moduleType = options.moduleType || ''
    params.optionType = options.optionType || ''
    params.operatePage = options.operate_page || ''
    params.param1 = options.param1 || ''
    params.param2 = options.param2 || ''
    params.param3 = options.param3 || ''
    params.param4 = JSON.stringify(options.param4) || ''
    params.param5 = options.params5 || options.param5 || ''

    that.post(options.postUrl, params, () => {
      callback && callback()
    }, () => {
    }, self, true)
  },

  openPdf(fileId, isPdf, callback, self) {
    if (this.getLocalStorage('isApp') && fileId && isPdf) {
      this.getUserStatus(self, () => {
        api.sendEvent({
          name: 'openPdf',
          extra: {
            fileId: fileId
          }
        })
      }, () => {

      }, {
        name: self.$route.name,
        fullPath: window.location.href
      },
      self._Enums.ENUMS_USER_STATUS.VIP
      )
    } else {
      callback && callback()
    }
  },

  dateFormat(timeSpan, format) {
    if (!timeSpan) {
      return
    }

    const date = new Date(timeSpan)
    const o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      'S': date.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (const k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }

    return format
  },

  /**
   * 根据传入的时间戳判断是不是今天
   * @param {number} timestamp 需要判断的时间戳
   * @return {boolean} 是否是今天
   */
  isToday(timestamp) {
    const [pastTime, nowTime] = [new Date(timestamp), new Date()]
    const [pastYear, pastMonth, pastDay] = [pastTime.getFullYear(), pastTime.getMonth() + 1, pastTime.getDate()]
    const [nowYear, nowMonth, nowDay] = [nowTime.getFullYear(), nowTime.getMonth() + 1, nowTime.getDate()]
    return pastYear === nowYear && pastMonth === nowMonth && pastDay === nowDay
  },

  shoppingHtmlInit() {
    // let dpr, rem, scale
    const docEl = document.documentElement
    let fontEl
    if (document.getElementById('_shoppingHtmlInit')) {
      fontEl = document.getElementById('_shoppingHtmlInit')
    } else {
      fontEl = document.createElement('style')
      fontEl.id = '_shoppingHtmlInit'
      docEl.firstElementChild.appendChild(fontEl)
    }
    const rem = docEl.clientWidth * 0.1
    fontEl.innerHTML = 'html{font-size:' + rem + 'px!important;}'
  },

  acSendEvent(options) {
    api.sendEvent({
      name: options.name,
      extra: options.extra
    })
  },

  randomChar(len) {
    const chars = 'abcdefghijklmnopqrstuvwxyz123456789'
    const maxPos = chars.length
    let pwd = ''
    for (var i = 0; i < (len || 32); i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  },

  matchEmotion(text) {
    const faceList = [
      { key: 'Expression_1', text: '[微笑]' },
      { key: 'Expression_2', text: '[撇嘴]' },
      { key: 'Expression_3', text: '[色]' },
      { key: 'Expression_4', text: '[发呆]' },
      { key: 'Expression_5', text: '[得意]' },
      { key: 'Expression_6', text: '[流泪]' },
      { key: 'Expression_7', text: '[害羞]' },
      { key: 'Expression_8', text: '[闭嘴]' },
      { key: 'Expression_9', text: '[睡]' },
      { key: 'Expression_10', text: '[大哭]' },
      { key: 'Expression_11', text: '[尴尬]' },
      { key: 'Expression_12', text: '[发怒]' },
      { key: 'Expression_13', text: '[调皮]' },
      { key: 'Expression_14', text: '[呲牙]' },
      { key: 'Expression_15', text: '[惊讶]' },
      { key: 'Expression_16', text: '[难过]' },
      { key: 'Expression_17', text: '[酷]' },
      { key: 'Expression_18', text: '[冷汗]' },
      { key: 'Expression_19', text: '[抓狂]' },
      { key: 'Expression_20', text: '[吐]' },
      { key: 'Expression_21', text: '[偷笑]' },
      { key: 'Expression_22', text: '[愉快]' },
      { key: 'Expression_23', text: '[白眼]' },
      { key: 'Expression_24', text: '[傲慢]' },
      { key: 'Expression_25', text: '[饥饿]' },
      { key: 'Expression_26', text: '[困]' },
      { key: 'Expression_27', text: '[恐惧]' },
      { key: 'Expression_28', text: '[流汗]' },
      { key: 'Expression_29', text: '[憨笑]' },
      { key: 'Expression_30', text: '[悠闲]' },
      { key: 'Expression_31', text: '[奋斗]' },
      { key: 'Expression_32', text: '[咒骂]' },
      { key: 'Expression_33', text: '[疑问]' },
      { key: 'Expression_34', text: '[嘘]' },
      { key: 'Expression_35', text: '[晕]' },
      { key: 'Expression_36', text: '[疯了]' },
      { key: 'Expression_37', text: '[衰]' },
      { key: 'Expression_38', text: '[骷髅]' },
      { key: 'Expression_39', text: '[敲打]' },
      { key: 'Expression_40', text: '[再见]' },
      { key: 'Expression_41', text: '[擦汗]' },
      { key: 'Expression_42', text: '[抠鼻]' },
      { key: 'Expression_43', text: '[鼓掌]' },
      { key: 'Expression_44', text: '[糗大了]' },
      { key: 'Expression_45', text: '[坏笑]' },
      { key: 'Expression_46', text: '[左哼哼]' },
      { key: 'Expression_47', text: '[右哼哼]' },
      { key: 'Expression_48', text: '[哈欠]' },
      { key: 'Expression_49', text: '[鄙视]' },
      { key: 'Expression_50', text: '[委屈]' },
      { key: 'Expression_51', text: '[快哭了]' },
      { key: 'Expression_52', text: '[阴险]' },
      { key: 'Expression_53', text: '[亲亲]' },
      { key: 'Expression_54', text: '[吓]' },
      { key: 'Expression_55', text: '[可怜]' },
      { key: 'Expression_56', text: '[菜刀]' },
      { key: 'Expression_57', text: '[西瓜]' },
      { key: 'Expression_58', text: '[啤酒]' },
      { key: 'Expression_59', text: '[篮球]' },
      { key: 'Expression_60', text: '[乒乓]' },
      { key: 'Expression_61', text: '[咖啡]' },
      { key: 'Expression_62', text: '[饭]' },
      { key: 'Expression_63', text: '[猪头]' },
      { key: 'Expression_64', text: '[玫瑰]' },
      { key: 'Expression_65', text: '[凋谢]' },
      { key: 'Expression_66', text: '[嘴唇]' },
      { key: 'Expression_67', text: '[爱心]' },
      { key: 'Expression_68', text: '[心碎]' },
      { key: 'Expression_69', text: '[蛋糕]' },
      { key: 'Expression_70', text: '[闪电]' },
      { key: 'Expression_71', text: '[炸弹]' },
      { key: 'Expression_72', text: '[刀]' },
      { key: 'Expression_73', text: '[足球]' },
      { key: 'Expression_74', text: '[瓢虫]' },
      { key: 'Expression_75', text: '[便便]' },
      { key: 'Expression_76', text: '[月亮]' },
      { key: 'Expression_77', text: '[太阳]' },
      { key: 'Expression_78', text: '[礼物]' },
      { key: 'Expression_79', text: '[拥抱]' },
      { key: 'Expression_80', text: '[强]' },
      { key: 'Expression_81', text: '[弱]' },
      { key: 'Expression_82', text: '[握手]' },
      { key: 'Expression_83', text: '[胜利]' },
      { key: 'Expression_84', text: '[抱拳]' },
      { key: 'Expression_85', text: '[勾引]' },
      { key: 'Expression_86', text: '[拳头]' },
      { key: 'Expression_87', text: '[差劲]' },
      { key: 'Expression_88', text: '[爱你]' },
      { key: 'Expression_89', text: '[NO]' },
      { key: 'Expression_90', text: '[OK]' },
      { key: 'Expression_91', text: '[爱情]' },
      { key: 'Expression_92', text: '[飞吻]' },
      { key: 'Expression_93', text: '[跳跳]' },
      { key: 'Expression_94', text: '[发抖]' },
      { key: 'Expression_95', text: '[怄火]' },
      { key: 'Expression_96', text: '[转圈]' },
      { key: 'Expression_97', text: '[磕头]' },
      { key: 'Expression_98', text: '[回头]' },
      { key: 'Expression_99', text: '[跳绳]' },
      { key: 'Expression_100', text: '[投降]' },
      { key: 'Expression_101', text: '[激动]' },
      { key: 'Expression_102', text: '[街舞]' },
      { key: 'Expression_103', text: '[献吻]' },
      { key: 'Expression_104', text: '[左太极]' },
      { key: 'Expression_105', text: '[右太极]' }
    ]
    let emotion = {}
    for (let i = 0, len = faceList.length; i < len; i++) {
      if (text == faceList[i].text) {
        emotion = faceList[i]
        break
      }
    }
    return emotion
  },

  /**
   * 用户打开微信页面获取当前定位
   * @param {Object} self Util方法的本身
   * @param {Bollen} getAgain 当为真时，表示是领取课程页面再次唤起获取定位
   */
  getLocation(self, getAgain) {
    const that = this
    if (!getAgain) {
      if (sessionStorage.getItem('isGetLocation') == 1) {
        return
      }
      sessionStorage.setItem('isGetLocation', 1)
    }

    if (that.isApp()) {
      // that.isGetLocationService();
    }
  },

  /** 微信端获取地理位置 */
  wxGetLocation(config, self) {
    const that = this
    wx.config({
      debug: false,
      appId: config.appId,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: ['getLocation']
    })
    wx.ready(function() {
      wx.checkJsApi({
        jsApiList: [
          'getLocation'
        ],
        success: function(res) {
          if (res.checkResult.getLocation == false) {
            console.log('你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！')
            return
          }
        }
      })
      wx.error(function(res) {
        console.log('config信息验证失败')
      })
      wx.getLocation({
        type: 'gcj02',
        success: function(res) {
          window.$bus.$emit('sentpotInfo', res)
          // /v2/epidemicMap 为疫情期间紧急上线功能 要允许未关注人员的使用
          if (window.location.pathname !== '/v2/epidemicMap') {
            that.saveLocation(res, self)
          }
        },
        fail: function(res) {
          window.$bus.$emit('getLocationFail')
          console.log('获取位置失败' + JSON.stringify(res))
        },
        cancel: function(res) {
          // Toast({
          //   message: '用户拒绝授权获取地理位置',
          //   duration: 2000
          // });
        }
      })
    })
  },

  /**
   * 提交经纬度给后端
   * @param {Object} 经纬度信息
   * @param {Object} Util方法的本身
   * @param {String} lessionId 领取的课程id
   */
  saveLocation(data, self, lessionId) {
    const that = this
    const result = gcoord.transform(
      [Number(data.longitude), Number(data.latitude)], // 经纬度坐标
      gcoord.GCJ02, // 当前坐标系
      gcoord.BD09 // 目标坐标系
    )
    const params = {
      source: that.isApp() ? 'APP' : 'WEIXIN',
      platForm: that.isIOS ? 'IOS' : 'Android',
      latitude: result[1],
      longitude: result[0]
    }
    if (lessionId) {
      params.param = lessionId
      params.courseKind = data.courseKind
      params.remark = data.courseKind == 1 || data.courseKind == 2 ? 'param为课程id' : 'param为班课id'
    }
    that.post(self._Api.POST_CURENT_LOCATION, params, (data) => {
      if (lessionId) {
        window.$bus.$emit('getLessionSuccess')
      }
    }, () => {
    }, self, true)
  },

  /** 压缩图片 */
  compressImg(evt, callBack) {
    var file = evt.target.files[0]
    var size = file.size / 1024
    console.log('图片大小' + size)
    if (!file.type.includes('image')) {
      Toast({
        message: '请上传图片文件',
        duration: 2000
      })
      return
    }
    if (size < 2000 || file.type == 'image/gif') {
      callBack(file)
    } else {
      var reader = new FileReader()
      reader.onload = function(e) {
        // console.log(e.target.result);
        var img = new Image()
        img.src = e.target.result
        img.onload = function() {
          var canvas = document.createElement('canvas')
          var context = canvas.getContext('2d')

          // 图片原始尺寸
          var w = this.width / 2
          var h = this.height / 2
          canvas.width = w
          canvas.height = h
          context.clearRect(0, 0, w, h)
          context.drawImage(img, 0, 0, w, h)

          var base64 = canvas.toDataURL('image/jpeg', 0.7)
          var binStr = atob(base64.split(',')[1]) // 对用base-64编码过的字符串进行解码
          var u8arr = new Uint8Array(binStr.length)
          var imgFile = file
          for (var i = 0; i < binStr.length; i++) {
            u8arr[i] = binStr.charCodeAt(i) // 返回字符的 Unicode 编码
          }
          var blob = new Blob([u8arr], { type: imgFile.type }) // 类文件对象
          console.log(blob.size / 1024)
          callBack(blob)
          img = null
        }
      }
      reader.readAsDataURL(file)
    }
  },

  /**
   * 用于canvas绘图时，图片加载回调的promise封装
   * @param {string} src 图片url
   */
  async imgLoaded(src) {
    return new Promise((resolve, reject) => {
      const _img = new Image()
      _img.crossOrigin = ''
      _img.onload = function() {
        resolve(_img)
      }
      _img.src = src
    })
  },

  /**
   * 生成水印图片
   * @param {object} 上传的文件内容
   * @param {string} txt 水印文案
   * @param {string} direction 水印位置
   * @param {boolean} isLogo 是否显示 logo
   * @param {String} model 哪个模块调用的
   * @param {function} callBack 图片水印生成之后的回调
   */
  watermarkImg(evt, { txt, direction, isLogo, model }, callBack) {
    var that = this
    var file
    if (evt.target && evt.target.files) {
      file = evt.target.files[0]
    } else {
      file = evt
    }
    var size = file.size / 1024
    console.log('图片大小' + size)
    if (!file.type.includes('image')) {
      Toast({
        message: '请上传图片文件',
        duration: 2000
      })
      return
    }
    if ((!txt && !isLogo) || file.type == 'image/gif') {
      callBack(file)
    } else {
      var reader = new FileReader()
      reader.onload = async function(e) {
        var bgImg = await that.imgLoaded(e.target.result)

        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        // 图片原始尺寸
        var w = bgImg.width
        var h = bgImg.height
        var scale = w / h
        var canvas_w
        canvas_w = 640
        if (model === 'community') {
          canvas_w = w > 2500 ? 2500 : w
        }
        var canvas_h = parseInt(canvas_w / scale)
        var _rem = canvas_w * 0.04
        canvas.width = canvas_w
        canvas.height = canvas_h
        context.clearRect(0, 0, canvas_w, canvas_h)
        context.drawImage(bgImg, 0, 0, w, h, 0, 0, canvas_w, canvas_h)

        context.shadowColor = 'rgba(46,49,68,0.54)'
        context.shadowOffsetX = 2
        context.shadowOffsetY = 2
        context.shadowBlur = 2
        context.font = 1.2 * _rem + 'px serif'
        context.fillStyle = 'rgba(255, 255, 255, 0.9)'
        if (model === 'community') { // 社区发帖图片的规则： 正中间名字，左下角logo
          context.font = _rem + 'px serif'
          var logoImg = await that.imgLoaded('https://kaxiubaodian-test.jieletong.com/shuiyin/logo.png')
          context.textAlign = 'center'
          context.fillText(txt, canvas_w / 2, canvas_h / 2)
          context.drawImage(logoImg, 20, canvas_h - 2.5 * _rem, 8 * _rem, 2 * _rem)
        } else {
          if (isLogo) {
            var logoImg1 = await that.imgLoaded('https://kaxiubaodian-test.jieletong.com/shuiyin/logo.png')
            if (direction === 'Center') {
              context.drawImage(logoImg1, canvas_w / 2 - (5 * _rem) / 2, canvas_h / 2, 5 * _rem, 1.4 * _rem)
            } else if (direction === 'South') {
              context.drawImage(logoImg1, canvas_w / 2 - (5 * _rem) / 2, canvas_h - 2 * _rem, 5 * _rem, 1.4 * _rem)
            } else {
              context.drawImage(logoImg1, _rem / 2, canvas_h - 2 * _rem, 5 * _rem, 1.4 * _rem)
            }
          } else {
            var logoImg2 = await that.imgLoaded('https://kaxiubaodian-test.jieletong.com/shuiyin/logo.png')
            if (direction === 'Center') {
              context.textAlign = 'center'
              context.fillText(txt, canvas_w / 2, canvas_h / 2)
              context.drawImage(logoImg2, canvas_w / 2 - context.measureText(txt).width / 2 - 1.5 * _rem, canvas_h / 2 - 1.6 * _rem / 2, 1.5 * _rem, 1.3 * _rem)
            } else if (direction === 'South') {
              context.textAlign = 'center'
              context.textBaseline = 'bottom'
              context.fillText(txt, canvas_w / 2, canvas_h - _rem)
              context.drawImage(logoImg2, canvas_w / 2 - context.measureText(txt).width / 2 - 1.5 * _rem, canvas_h - 1.9 * _rem, 1.5 * _rem, 1.3 * _rem)
            } else {
              context.textAlign = 'left'
              context.textBaseline = 'bottom'
              context.fillText(txt, _rem + 1.3 * _rem, canvas_h - _rem)
              context.drawImage(logoImg2, 0.9 * _rem, canvas_h - 2 * _rem, 1.5 * _rem, 1.3 * _rem)
            }
          }
        }

        var base64 = canvas.toDataURL()
        var binStr = atob(base64.split(',')[1]) // 对用base-64编码过的字符串进行解码
        var u8arr = new Uint8Array(binStr.length)
        var imgFile = file
        for (var i = 0; i < binStr.length; i++) {
          u8arr[i] = binStr.charCodeAt(i) // 返回字符的 Unicode 编码
        }
        var blob = new Blob([u8arr], { type: imgFile.type }) // 类文件对象
        console.log(blob.size / 1024)
        const newFile = new File([blob], 'water.png')
        callBack(newFile)
        bgImg = null
      }
      reader.readAsDataURL(file)
    }
  },

  /**
   * fix 安卓下 因为键盘弹出导致底部标签栏 顶起的问题
   * @param {string} targetId 需要修复的标签id
   */
  fixTabbar(targetId) {
    if (!this.isIOS) {
      const client_h = document.documentElement.clientHeight
      window.onresize = function() {
        const body_h = document.body.scrollHeight
        const tabbar = document.getElementById(targetId)
        if (tabbar) {
          if (body_h < client_h) {
            tabbar.style.position = 'static'
          } else {
            tabbar.style.position = 'fixed'
          }
        }
      }
    }
  },

  /**
   * 比较版本号,如果当前app版本大于等于限制的最小版本，则返回true
   * @param {string} appVer app的版本号
   * @param {string} limitVer 限制的版本号
   * @return {boolean}
   */
  compareVersion(appVer, limitVer) {
    const appVerArr = appVer.split('.')
    const limitVerArr = limitVer.split('.')
    const loopLength = Math.min(appVerArr.length, limitVerArr.length)
    let result = null
    for (let i = 0; i < loopLength; i++) {
      if (appVerArr[i] < limitVerArr[i]) {
        result = false
        break
      } else if (appVerArr[i] == limitVerArr[i]) {
        result = true
        continue
      } else {
        result = true
        break
      }
    }
    return result
  },

  /**
   * 对象转查询字符串
   * @param {object} obj 需要转查询字符串的对象
   * @return queryString
   */
  objectToQueryString(obj) {
    return Object.keys(obj).map(function(key) {
      return ''.concat(encodeURIComponent(key), '=').concat(encodeURIComponent(obj[key]))
    }).join('&')
  },

  /**
   * 根据 url 查询字符串 解析 对象
   * @param {string} url
   * @returns {Object}
   */
  param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse(
      '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
    )
  },

  /**
   * 统一的神策埋点记录方法
   * @param {string} eventName 事件名称
   * @param {object} properties 事件属性
   * @return Promise实例对象
   * @description 神策埋点本身已开启批量发送埋点功能，大部分情况下无需等待埋点接口回调后，再执行后续逻辑；
   * promise只是用来处理某些特殊情况
   */
  sensorsCollect(eventName, properties) {
    return
    /* eslint-disable */
    const isApp = this.getLocalStorage('isApp')
    const browserObj = this.getUserAgent()
    const version = localStorage.getItem('newVersion') ? localStorage.getItem('newVersion') : this.version

    const params = {
      source: isApp ? 'APP' : 'WEIXIN',
      platForm: browserObj.platForm || '',
      version: isApp ? version : '',
      kernel: browserObj.browserKernel[0] || '',
      userStatus: JSON.parse(localStorage.getItem('userInfo')).userStatus || 0
    }

    return new Promise((resolve, reject) => {
      sensors.track(eventName, {
        ...params,
        ...properties
      }, function () {
        resolve()
      })
    })
    /* eslint-enable */
  },

  /**
   * 神策$WebClick事件，自定义元素触发
   * 点击热力图，自定义元素的点击事件采集
   * @param {node} target 点击元素  event.target
   * @param {object} properties 自定义属性
   * @return Promise实例对象
   * @description 神策埋点本身已开启批量发送埋点功能，大部分情况下无需等待埋点接口回调后，再执行后续逻辑；
   * promise只是用来处理某些特殊情况
   */
  sensorsHeatMap(target, properties) {
    return
    /* eslint-disable */
    return new Promise((resolve, reject) => {
      sensors.quick('trackHeatMap', target, {...properties}, () => {
        resolve()
      })
    })
    /* eslint-enable */
  },

  /**
   * 转换时间格式
   * @param {(Object|string|number)} time
   * @param {string} cFormat
   * @returns {string}
   */
  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      }
      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  },
  /**
   * 查看资料时，校验权限
   * @param {Object} params 校验接口需要的参数
   *  {
        dataType: 'DATA_DAQO', // 对资料进行权限判断，其他可选值：FAULT_CODE（故障码），TEST_DATA（测试数据），PARTS_INFO（部件信息），PRODUCT_LIBRARY（产品库）
        params: {
          eventType: 'SEARCH_DATA' // SEARCH_DATA（搜索事件）,DETAILS_DATA (点击查看详情事件)
        }
      }
   * @param {Object} self vue对象
   */
  judgePower(params, self) {
    const that = this
    return new Promise((resolve, reject) => {
      self.$http.post(self._Api.POST_JUDGE_POWER, params).then((response) => {
        switch (response.data.status) {
          case 200:
            resolve(response.data.data)
            break
          case 4000:
            that.showMsgBox(response.data.msg)
            break
          case 4001:
            that.showMsgBoxConfirm('请认证后操作', action => {
              if (action) {
                window.top.location.href = '/v2/member/personalCertification?fullPath=' + self.$route.fullPath
              }
            })
            break
          // 认证
          case 4002:
            // 会员中心
            that.showMsgBoxConfirm('对不起，只有付费会员才能查看。您还未付费，请您先完成付费', action => {
              if (action) {
                window.location.href = '/v2/business/pay/certificationRenewal?fullPath=' + self.$route.fullPath
              }
            })
            break
        }
      }).catch((error) => {
        that.showMsgBox('服务器异常,请稍候再试')
        reject(error)
      })
    })
  },

  /**
   * 监听设备平板打开网页，并传递资料的url给设备端，供设备端获取该url执行打开详情窗口等操作
   * @param {Object} params
   */
  AddEventFmt100Url(url) {
    if (window.android && window.android.setNextUrl) {
      window.android.setNextUrl(url)
      return
    }
  },

  /**
   * mPaaS-JSBridage 注入完成
   * @param {function} callback 回到函数
   */
  JSBridgeReady(callback) {
    // 如果 jsbridge 已经注入则直接调用
    if (window.AlipayJSBridge) {
      callback && callback()
    } else {
      // 如果没有注入则监听注入的事件
      document.addEventListener('AlipayJSBridgeReady', callback, false)
    }
  },

  /**
   * mPaaSs检验登录
   * @param {Object} toPath 要跳转的页面路径对象，一般指的是vurrouter的路由对象
   * @param {Object} params 携带的参数,当toPath为空时，此处一个回调函数
   */
  mpassCheckSession(toPath, params, self) {
    if (this.subFlag) {
      this.subFlag = false
      setTimeout(() => {
        this.subFlag = true
      }, 500)
      this.post(self._Api.POST_WXAUTH_CHECK_SESSION_MPASS, {
        appToken: localStorage.getItem('app-token') || ''
      }, (data) => {
        if (!data.verifyStatus) {
          this.mPassRouter({ fullPath: location.origin + '/v2/login?loginPage=loginPage' }, {})
        } else {
          if (toPath) {
            this.mPassRouter(toPath, params)
          } else {
            params && params.call(self)
          }
        }
      }, () => {
      }, self, true)
    }
  },

  /**
   * mPaaS的路由跳转
   * @param {Object} toPath 要跳转的页面路径对象，一般指的是vurrouter的路由对象
   * @param {Object} params 携带的参数
   */
  mPassRouter(toPath, params = {}) {
    if (this.isMiniApp()) {
      if (toPath.fullPath.indexOf(location.origin) === -1) {
        toPath.fullPath = location.origin + toPath.fullPath
      }
      const src = encodeURIComponent(toPath.fullPath)
      my.navigateTo({url: `/pages/webView/webView?src=${src}`}) // eslint-disable-line
      return
    }
    this.JSBridgeReady(() => {
      AlipayJSBridge.call('pushWindow', { // eslint-disable-line
        url: toPath.fullPath, // 要打开页面的 URL
        // 打开页面的配置参数
        param: {
          showLoading: false,
          backBehavior: 'auto',
          readTitle: true, // 自动读取 title
          showOptionMenu: true, // 显示右上角按钮
          titleBarColor: '#177AFA'
        },
        // 用于给新开的页面传递参数，可选
        // 在新开的页面使用 AlipayJSBridge.startupParams 可以获取到 passData
        passData: params.data
      })
    })
  },

  /**
   * mPaaS的分享
   * @param {Object} params 分享的内容
   * @param {Function} cb 分享成功回调
   */
  mpassShare(params, cb) {
    window.AlipayJSBridge && AlipayJSBridge.call('gzopenShare', params, (data) => { // eslint-disable-line
      cb && cb(data)
    })
  },

  /**
   * mPaaS隐藏分享按钮
   * @param {Object} params 分享的内容
   * @param {Function} cb 分享成功回调
   */
  mpassHideOptionMenu() {
    window.AlipayJSBridge && AlipayJSBridge.call('hideOptionMenu')  // eslint-disable-line
  },

  /**
   * mPaaS的支付宝支付
   * @param {Object} params 分享的内容
   * @param {Function} cb 分享成功回调
   */
  mpassAlipay(params, cb) {
    window.AlipayJSBridge && AlipayJSBridge.call('gzAlipay', params, (data) => { // eslint-disable-line
      // alert('支付完成')
      cb && cb()
    })
  },

  /**
   * 判断是否是小程序打开
   */
  isMiniApp() {
    const ua = navigator.userAgent.toLowerCase()
    let falg
    if (ua.indexOf('miniprogram') != -1) {
      falg = true
    } else {
      falg = false
    }
    return falg
  },
  /**
   * 支付宝小程序、微信小程序打开PDF文件
   * @param {String} href
   */
  openPDFFile(href) {
    let url = href
    if (localStorage.getItem('inWxMinapp') === '1') {
      // 微信小程序
      url = href + `&appToken=${localStorage.getItem('wxMiniAppToken')}`
    }
    if (localStorage.getItem('inMpassMinapp') === '1') {
      // mpass小程序
      url =
        href +
        `&appToken=${localStorage.getItem('mpassMiniAppToken')}&source=APP`
    }
    return url
  },
  /**
   * 公共的页面跳转方法
   * @param {Object} routerObj 需要打开的跳转对象
   * routerObj.appName 只在apicloud app上打开才需要传递
   */
  publicOpenPage(routerObj) {
    if (localStorage.getItem('inWxMinapp') === '1') { // 微信小程序
      const src = encodeURIComponent(routerObj.url)
      let url = `/pages/webView/webView?src=${src}`
      if (routerObj.url.indexOf('/v4/') !== -1) {
        const arr = routerObj.url.split('/v4')
        url = arr[1] || ''
      }
      uni.navigateTo({ // eslint-disable-line
        url
      })
      return
    }
    if (this.isApp()) {
      api.sendEvent({
        name: 'acOpenNewFrm',
        extra: {
          name: routerObj.appName,
          url: routerObj.url
        }
      })
    } else {
      location.href = routerObj.url
    }
  },
  getParaValueByName(paraName) {
    var reg = new RegExp('(^|&)' + paraName + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    } else {
      return ''
    }
  },
  isVip(userVipType) {
    return (userVipType & 2) == 2
  },
  isSVip(userVipType) {
    return (userVipType & 1) == 1
  }
}

